module.exports = __webpack_public_path__ + "6540183bdc50ec56b5d491f8996af837.svg";